/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import Select, { CSSObjectWithLabel } from 'react-select'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { Tr } from '../../../../_metronic/i18n/Tr'
import 'react-phone-input-2/lib/style.css'


const ViewInsayrCommissionFees = () => {
    let t = Tr()
    const { menuIdEdit } = useMenuIdPermissions()
    const [error, setError] = useState(Object)
    const [listData, setListData] = useState([])
    const [currentCommissionData, setCurrentCommissionData] = useState([])
    const [totalRecords, setTotalRecords] = useState('') as any
    const [limit, setLimit] = useState(5)
    const [offset, setOffset] = useState(0)

    const [commissionData, setCommissionData] = useState([
        { settingId: '', key: '', value: '', year: '', month: '', oldCommission: '' },
    ])

    const [insayrCommissionLoading, setInsayrCommissionLoading] = useState(false)


    const currentYear = new Date().getFullYear()
    const yearList = Array.from({ length: 11 }, (_, i) => ({
        value: (currentYear + i).toString(),
        label: (currentYear + i).toString(),
    }))

    const [monthList] = useState([
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
    ]) as any

    const commissionDetailApiCall = async () => {
        var response: any = await fetchData('admin/commissionSettingList', {})

        if (response.status == '200') {
            var data = response.data
            const trimData = (data: any[]) => {
                return data.map((item) => ({
                    settingId: item.settingId !== '' ? item.settingId : '',
                    key: item.key !== '' ? item.key : '',
                    value: '',
                    year: '',
                    month: '',
                    oldCommission: item.oldCommission,
                    nextMonthDate: item.nextMonthDate,
                }))
            }

            const trimmedData = trimData(data)

            // Sort the data to ensure Accommodation Vendor Commission (7) appears first
            const sortedData = [...trimmedData].sort((a, b) => {
                if (a.settingId === '7') return -1 // Move Accommodation to the top
                if (b.settingId === '7') return 1
                return 0 // Keep others in their original order
            })

            setCommissionData(sortedData)
        } else {
            toasterrormsg(response.message)
        }
    }

    //   hotel list api call
    const commissionHistoryListApiCall = async () => {
        var param: any = {
            limit: limit,
            offset: offset,
        }

        var res = await fetchData('admin/commissionhistorylist', param)

        if (res.status == '200') {
            var data = res.data
            setTotalRecords(data.totalRecords)
            setListData(data.data)
        } else {
            toasterrormsg(res.message)
        }
    }

    const currentCommisionListApiCall = async () => {
        var param: any = {
            limit: limit,
            offset: offset,
        }

        var res = await fetchData('admin/latestCommision', param)

        if (res.status == '200') {
            var data = res.data

            setCurrentCommissionData(data)
        } else {
            toasterrormsg(res.message)
        }
    }



    useEffect(() => {
        commissionDetailApiCall()
        currentCommisionListApiCall()
    }, [])

    useEffect(() => {
        commissionHistoryListApiCall()
    }, [limit, offset])

    const removeError = (index: number, field: any) => {
        setError((prevError: any) => {
            const newError = { ...prevError }
            delete newError[`${field}${index}`]
            return newError
        })
    }

    const commissionValidate = () => {
        const errotmp: any = {}
        let err = 0

        const currentDate = new Date()
        const currentMonth = currentDate.getMonth() + 1 // getMonth() is 0-based
        const currentYear = currentDate.getFullYear()

        commissionData.forEach((commissionSlot: any, index: number) => {
            const selectedMonth = commissionSlot.month ? parseInt(commissionSlot.month) : null
            const selectedYear = commissionSlot.year ? parseInt(commissionSlot.year) : null

            // Check if the row has any filled value
            if (commissionSlot.value) {
                // Validate required fields
                if (!selectedMonth) {
                    errotmp[`month${index}`] = t('Month Is required')
                    err = 1
                }

                if (!selectedYear) {
                    errotmp[`year${index}`] = t('Year Is required')
                    err = 1
                }

                if (selectedYear && selectedYear < currentYear) {
                    errotmp[`year${index}`] = t("Year can't be Smaller than the current Year")
                    err = 1
                }

                if (selectedMonth && selectedYear == currentYear && selectedMonth < currentMonth) {
                    errotmp[`month${index}`] = t("Month can't be Smaller than the current month")
                    err = 1
                } else if (selectedMonth && selectedYear == currentYear && selectedMonth == currentMonth) {
                    errotmp[`month${index}`] = t("Month can't be Equal To current month")
                    err = 1
                }
            }
        })

        setError(errotmp)
        if (err === 0) {
            saveCommission()
        }
    }

    const saveCommission = async () => {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
            // Step 3: Parse the JSON string
            var adminData = JSON.parse(tmp2)
            // Step 4: Access the adminId
            var adminId = adminData.adminId
        }

        const allEmpty = commissionData.every(
            (item) =>
                item.value.trim() === '' || item.value.trim() == null || item.value.trim() == undefined
        )

        if (allEmpty) {
            toasterrormsg('Please Fill Atleast One Value Before Submitting.')
            return
        }

        setInsayrCommissionLoading(true)


        for (const item of commissionData) {
            if (item.value != '' && item.value != undefined && item.value != null) {
                const param = {
                    settingId: item.settingId,
                    value: Number(item.value),
                    adminId: adminId,
                    year: item.year,
                    month: item.month,
                }
                var res = await fetchData('admin/editcommissionsetting', param)
            }
        }

        if (res.status == '200') {
            toastsuccessmsg('Updated Successfully')
            setInsayrCommissionLoading(false)

            commissionDetailApiCall()
            commissionHistoryListApiCall()

            currentCommisionListApiCall()
        } else {
            setInsayrCommissionLoading(false)

            toasterrormsg(res.message)
        }
    }

    const handleacccommodationchange = (index: number, field: any, value: any) => {
        if (field == 'value' && !/^\d*\.?\d*$/.test(value)) {
            return // Exit early if the value is not numeric or a decimal
        } else if (field == 'value' && value > 100) {
            return
        } else if (field == 'value' && value < 1 && value > 0.99) {
            return
        } else {
            var accomodationslots: any = [...commissionData]
            accomodationslots[index][field] = value
            setCommissionData(accomodationslots)
        }
    }

    useEffect(() => {
        document.title = 'Insayr | Insayr Commission Fees'
    }, [])

    const column = useMemo(
        () => [
            {
                name: t('Vendor Type'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
                            <label className='cursor-pointer'>
                                {row.categoryId == '1'
                                    ? t('Accommodation Vendor')
                                    : row.categoryId == '4'
                                        ? t('Space Vendor')
                                        : row.categoryId == '5'
                                            ? t('Tour Vendor')
                                            : row.categoryId == '7'
                                                ? t('Car Vendor')
                                                : ''}
                            </label>
                        </div>
                    </div>
                ),
                sortable: false,
                filter: true,
                width: '200px',
            },
            {
                name: t('Current Fee'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>
                            {row.oldCommission != '' &&
                                row.oldCommission != null &&
                                row.oldCommission != undefined
                                ? row.oldCommission + ' %'
                                : '0%'}
                        </div>
                    </div>
                ),
                sortable: true,
                filter: true,
                selector: (row: any) => Number(row.oldCommission),
            },
            {
                name: t('New Fee(%)'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>
                            <div className='fw-bold fs-5'>
                                {row.commission != '' && row.commission != null && row.commission != undefined
                                    ? row.commission + ' %'
                                    : '0%'}
                            </div>
                        </div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => Number(row.commission),
                filter: true,
            },
            {
                name: t('Effective From'),
                cell: (row: any) => {
                    const monthObj = monthList.find((m: any) => m.value === row.month)
                    const monthName = monthObj ? monthObj.label : row.month
                    return (
                        <div className='my-3'>
                            <div className='fw-bold fs-5'>
                                {monthName} {row.year}
                            </div>
                        </div>
                    )
                },
                sortable: true,
                selector: (row: any) => row.month,
                filter: true,
            },
            {
                name: t('Changed By'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
                            <label className='cursor-pointer'>{row.createdBy != '' ? row.createdBy : ''}</label>
                        </div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => row.month,
                filter: true,
            },
            {
                name: t('Change Date & Time'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
                            <label className='cursor-pointer'>
                                {row.created ? moment(row.created).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </label>
                        </div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => row.month,
                filter: true,
            },
        ],
        [t]
    )

    const column2 = useMemo(
        () => [
            {
                name: t('Vendor Type'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-6 d-flex align-items-center justify-content-center cursor-pointer'>
                            <label className='cursor-pointer'>
                                {row.categoryId == '1'
                                    ? t('Accommodation Vendor')
                                    : row.categoryId == '4'
                                        ? t('Space Vendor')
                                        : row.categoryId == '5'
                                            ? t('Tour Vendor')
                                            : row.categoryId == '7'
                                                ? t('Car Vendor')
                                                : ''}
                            </label>
                        </div>
                    </div>
                ),
                sortable: false,
                filter: true,
                width: '200px',
            },
            {
                name: t('Current Fee'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>
                            {row.oldCommission != '' &&
                                row.oldCommission != null &&
                                row.oldCommission != undefined
                                ? row.oldCommission + ' %'
                                : '0%'}
                        </div>
                    </div>
                ),
                sortable: true,
                filter: true,
                selector: (row: any) => Number(row.oldCommission),
            },
            {
                name: t('New Fee(%)'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>
                            <div className='fw-bold fs-5'>
                                {row.commission != '' && row.commission != null && row.commission != undefined
                                    ? row.commission + ' %'
                                    : '0%'}
                            </div>
                        </div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => Number(row.commission),
                filter: true,
            },
            {
                name: t('Effective From'),
                cell: (row: any) => {
                    const monthObj = monthList.find((m: any) => m.value === row.month)
                    const monthName = monthObj ? monthObj.label : row.month
                    return (
                        <div className='my-3'>
                            <div className='fw-bold fs-5'>
                                {monthName} {row.year}
                            </div>
                        </div>
                    )
                },
                sortable: true,
                selector: (row: any) => row.month,
                filter: true,
            },
        ],
        [t]
    )
    const handlePageChange = (newPage: number) => {
        const totalPages = Math.ceil(totalRecords / limit)

        if (newPage === 1) {
            setOffset(0)
        } else if (newPage === totalPages) {
            setOffset((totalPages - 1) * limit)
        } else {
            setOffset((newPage - 1) * limit)
        }
    }

    const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
        setLimit(newRowsPerPage)
    }

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{t('View Settings')}</PageTitle>

            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>
                            {t('Add')} {t('Insayr Commission Fees')}
                        </h3>
                    </div>
                </div>
                <div className='col-lg-12  mx-4 my-3'>
                    <span className='fw-bolder fs-5 form-label'>
                        {t('*Note:')}{' '}
                        <span className='fs-7 form-label'>{t('You Can Update Any Of The Commission')}</span>
                    </span>
                </div>
                <div className='card-body p-9'>
                    {commissionData.map((items: any, index: any) => (
                        <>
                            <div className='row mb-7'>
                                <div className='col-lg-4'>
                                    <label className='fw-bold text-muted'>{t(items.key)}</label>
                                    <div className='d-flex align-items-center gap-3'>
                                        <input
                                            type='text'
                                            placeholder={`${t("Enter Commission")}`}
                                            className='form-control form-control-solid w-100'
                                            value={items.value}
                                            onChange={(event: any) => {
                                                handleacccommodationchange(index, 'value', event.target.value)
                                                removeError(index, 'value')
                                            }}
                                        />
                                        {/* Percentage Label */}
                                        <span className='fw-bolder fs-6 text-dark'>%</span>
                                    </div>{' '}
                                    <label className='text-danger'>{error[`value${index}`] || ''}</label>
                                </div>
                                <div className='col-lg-3'>
                                    <label className='fw-bold text-muted'>{t('Effective Month')}</label>
                                    <div className='d-flex align-items-center gap-3'>
                                        <Select
                                            name='selectMonth'
                                            id='selectMonth'
                                            placeholder={t('Select Month')}
                                            isSearchable={true}
                                            options={monthList}
                                            value={monthList.find((option: any) => option.value === items.month) || null}
                                            onChange={(event: any) => {
                                                handleacccommodationchange(index, 'month', event.value)
                                                removeError(index, 'month')
                                            }}
                                            styles={{
                                                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                                                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
                                            }}
                                        />
                                    </div>{' '}
                                    <label className='text-danger'>{error[`month${index}`] || ''}</label>
                                </div>
                                <div className='col-lg-3'>
                                    <label className='fw-bold text-muted'>{t('Effective Year')}</label>
                                    <div className='d-flex align-items-center gap-3'>
                                        <Select
                                            name={`selectYear${index}`}
                                            id={`selectYear${index}`}
                                            placeholder={t('Select Year')}
                                            isSearchable={true}
                                            options={yearList}
                                            value={yearList.find((option: any) => option.value == items.year) || null}
                                            onChange={(event: any) => {
                                                handleacccommodationchange(index, 'year', event.value)
                                                removeError(index, 'year')
                                            }}
                                            styles={{
                                                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                                                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
                                            }}
                                        />
                                    </div>{' '}
                                    <label className='text-danger'>{error[`year${index}`] || ''}</label>
                                </div>
                            </div>
                        </>
                    ))}
                    {menuIdEdit ? (
                        <button
                            disabled={insayrCommissionLoading}

                            className='btn btn-success'
                            onClick={() => {
                                commissionValidate()
                            }}
                        >

                            {!insayrCommissionLoading && t('Save')}

                            {insayrCommissionLoading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    {t('Please wait...')}{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            </div>

            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>{t('Active Commission Rates')}</h3>
                    </div>
                </div>

                <DataTable
                    columns={column2}
                    data={currentCommissionData}
                    pagination
                    paginationServer={true}
                    onChangePage={handlePageChange}
                    paginationPerPage={5}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                    subHeader={true}
                    paginationComponentOptions={{
                        rowsPerPageText: t('Rows Per Page'),
                    }}
                />
            </div>

            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>{t('Commission Changes History')}</h3>
                    </div>
                </div>

                <DataTable
                    columns={column}
                    data={listData}
                    pagination
                    paginationServer={true}
                    onChangePage={handlePageChange}
                    paginationTotalRows={totalRecords}
                    paginationPerPage={5}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                    subHeader={true}
                    paginationComponentOptions={{
                        rowsPerPageText: t('Rows Per Page'),
                    }}
                />
            </div>



        </>
    )
}

export { ViewInsayrCommissionFees }
